import * as React from 'react';
import {Translation as T} from '../Other/Translation';

export interface TranslationPropsInterface {
	translationKey: string;
	language?: string;
}

export class InternalTranslation extends React.Component<TranslationPropsInterface, {}> {
	public render():JSX.Element {
		return (
			<>{T.l(this.props.translationKey)}</>
		)
	}
};
